const imagePlaceholder =
  "data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23A0AEC0' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%0A%3E%3Crect x='3' y='3' width='18' height='18' rx='2' ry='2' /%3E%3Ccircle cx='8.5' cy='8.5' r='1.5' /%3E%3Cpolyline points='21 15 16 10 5 21' /%3E%3C/svg%3E%0A"

export default imagePlaceholder
